/** Map permission menu icon names to AppSidebar Lucide icon component keys. */
export const SIDEBAR_ICON_MAP: Record<string, string> = {
  TabStudies: 'FileText',
  ListView: 'FileText',
  Settings: 'Building2',
  User: 'Users',
  LayoutDashboard: 'LayoutDashboard',
  Configuration: 'SlidersHorizontal',
  BellRing: 'BellRing',
  Clock: 'Clock',
  Siren: 'Siren',
  ShieldCheck: 'ShieldCheck',
  ClipboardCheck: 'ClipboardCheck',
  Home: 'Home',
  BarChart3: 'BarChart3',
};

export function mapMenuIconToSidebar(icon?: string): string | undefined {
  if (!icon) {
    return undefined;
  }
  return SIDEBAR_ICON_MAP[icon];
}
